module.exports = __webpack_public_path__ + "static/media/Illustration_Approvals.58605e7a.svg";